/* eslint-disable no-plusplus */
export const isOver18 = (birthDate: string | Date) => {
  // Create a Date object for the birthDate
  const birthDateObj = new Date(birthDate);

  // Get today's date
  const today = new Date();

  // Get the difference in years
  let ageInYears = today.getFullYear() - birthDateObj.getFullYear();

  // Adjust for months (if birthday hasn't happened this year yet)
  const month = today.getMonth() - birthDateObj.getMonth();
  if (month < 0 || (month === 0 && today.getDate() < birthDateObj.getDate())) {
    ageInYears--;
  }

  // Check if age is over 18
  return ageInYears >= 18;
};
